import React, { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';

const InfoWithOverlay = ({ content=null, content2 }) => {
    const op = useRef(null);

    return (
        <div className='text-sm text-white ml-0 my-2'>
            <OverlayPanel className='info' ref={op}>
                <div className="left-0 text-[#4B586E] text-[12px] rounded w-[16rem] z-10">
                    {content && (content)}
                    {content2}
                </div>
            </OverlayPanel>
            <i
                className="pi pi-info-circle"
                style={{ color: 'white', cursor: 'pointer' }}
                onClick={(e) => op.current.toggle(e)}
            ></i>
        </div>
    );
};

export default InfoWithOverlay;